export enum UserRequestName {
  changeOrgId = 'changeOrgId',
  createOrg = 'createOrg',
  createUser = 'createUser',
  updateUser = 'updateUser',
}
